import './Markdown.less';
import './Markdown.desktop.less';
import './Markdown.desktop.dark.less';

import clsx from 'clsx';
import Markdown2Jsx from 'markdown-to-jsx';
import React, { memo, useContext } from 'react';

import LinkInterceptor from '../link-interceptor/LinkInterceptor';
import defaultModules from './modules';
import MarkdownContext from './MarkdownContext';

function createOverrides(elementOverrides = {}, propsOverrides = {}) {
    return {
        a: {
            component: LinkInterceptor
        },
        'nike:module': {
            component: props => <NikeMarkdownModule {...props} {...propsOverrides} />
        },
        ...elementOverrides
    };
}

function NikeMarkdownModule({ id, ...rest }) {
    const { modules = {} } = useContext(MarkdownContext);
    const comps = Object.assign({}, defaultModules, modules);
    const C = comps[id];
    return C ? <C {...rest} /> : null;
}

function Markdown({
    className,
    overrides: over,
    children,
    forceInline = false,
    article = false,
    ...rest
}: {
    className?: string;
    overrides?: object;
    children?: any;
    forceInline?: boolean;
    article?: boolean;
}) {
    const overrides = createOverrides(over, rest);
    return (
        <Markdown2Jsx className={clsx('markdown', className, { article })} options={{ overrides, forceInline }}>
            {children}
        </Markdown2Jsx>
    );
}

export default memo(Markdown);
